<template>
  <div id="createOrder" class="container">
    <div class="page-t">填写订单详情</div>
    <div class="table">
      <div class="title">收货地址</div>
      <div class="form">
        <el-row>
          <el-col :span="12">
            <div class="adr-left">
              <div v-if="current_address == null">现在添加地址</div>
              <div>
                <el-row>
                  <el-col :span="4">收件人：</el-col>
                  <el-col :span="12">{{a_name}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">手机号：</el-col>
                  <el-col :span="12">{{a_mobile}}</el-col>
                  <el-col :span="4" :offset="4">
                    <div class="eidt-adr" @click="editDialog=true">修改地址</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">收货地址：</el-col>
                  <el-col
                    :span="12"
                  >{{a_address1+" " + a_address2+" " + a_address3+" " + a_address}}</el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="adr-right">
              <el-row :gutter="40">
                <el-col :span="8" :offset="2">
                  <div class="adr-btn" @click="editAdr()">
                    <i class="fas fa-home"></i>更改收货地址
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="adr-btn" @click="addAdr()">
                    <i class="fas fa-plus-circle"></i>添加收货地址
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="title">支付方式</div>
      <div class="form" align="center">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="btn" :class="way1 == 1? 'active':''" @click="way1 = 1">在线支付</div>
          </el-col>
          <el-col :span="6">
            <div class="btn" :class="way1 == 2? 'active':''" @click="way1 = 2;">货到付款</div>
          </el-col>
        </el-row>
      </div>

      <div class="title">发票信息</div>
      <div class="form" align="center">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="btn check-btn" @click="checkDialog=true" :class="check?'active':''">
              <div v-show="invoiceId == 0">
                <i class="far fa-square fa-lg"></i>我需要开发票
              </div>
              <div v-show="invoiceId > 0">
                <i class="far fa-check-square fa-lg"></i>我需要开发票
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="title">使用优惠券</div>
      <div class="form" align="center">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="coupon">
              <el-row>
                <el-col :span="8" style="height: 100px;background-color:#e2211c;">
                  <div class="coupon-left">
                    <div>&yen;50</div>
                    <div>满100可用</div>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="coupon-right">
                    <div>全品类通用券</div>
                    <div>使用平台：全平台</div>
                    <div>有效期至：2018-08-01</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="coupon">
              <el-row>
                <el-col :span="8" style="height: 100px;background-color:#e2211c;">
                  <div class="coupon-left">
                    <div>&yen;50</div>
                    <div>满100可用</div>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="coupon-right">
                    <div>全品类通用券</div>
                    <div>使用平台：全平台</div>
                    <div>有效期至：2018-08-01</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="list">
        <el-table header-row-class-name="row-header" :data="tableData" style="width: 100%">
          <el-table-column width="100">
            <template slot-scope="scope">
              <img
                class="cover"
                src="http://iph.href.lu/80x80?text=%E6%B5%8B%E8%AF%95%E6%B5%8B%E8%AF%95&bg=FFCCCC"
                :alt="scope.row.item_no"
              >
            </template>
          </el-table-column>
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <el-row :gutter="20">
                <el-col :span="5">
                  <div class="cover"></div>
                </el-col>
                <el-col :span="19">
                  <div>{{ scope.row.title }}</div>
                  <div class="item-no">货号：{{ scope.row.item_no }}</div>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="单价" width="120">
            <template slot-scope="scope">
              <div>&yen;{{ scope.row.selling_price }}</div>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="160" prop="number"></el-table-column>
          <el-table-column prop="address" label="小计" width="160">
            <template slot-scope="scope">
              <div>&yen;{{scope.row.number*scope.row.selling_price}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="title underline">商品信息</div>
      <div class="bot-text">
        <el-row :gutter="20">
          <el-col :span="4" :offset="16">商品件数：</el-col>
          <el-col :span="4">{{Object.keys(tableData).length}}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4" :offset="16">商品总价：</el-col>
          <el-col :span="4">&yen;{{total}}.00</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4" :offset="16">活动优惠：</el-col>
          <el-col :span="4">-&yen;0</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4" :offset="16">运费：</el-col>
          <el-col :span="4">-&yen;{{freight}}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4" :offset="16">应付总额：</el-col>
          <el-col :span="4">&yen;{{total}}.00</el-col>
        </el-row>
      </div>

      <div align="right">
        <el-button type="primary" class="submit" @click="submit()" :loading="submitLoading">提交订单</el-button>
      </div>
    </div>

    <el-dialog title="添加收货地址" :visible.sync="addDialog" width="50%" @closed="handelAddClose">
      <div>
        <el-row :gutter="50" style="margin-bottom:20px">
          <el-col :span="12">
            <el-input v-model="name" placeholder="请输入收货人姓名"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="mobile1" placeholder="请输入收货人手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-select v-model="address1" placeholder="请选择" @change="handeladr1">
              <el-option v-for="item in adr1" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="address2" placeholder="请选择" @change="handeladr2">
              <el-option v-for="item in adr2" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="address3" placeholder="请选择" @change="handeladr3">
              <el-option v-for="item in adr3" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <div style="margin-top:20px;">
          <el-input type="textarea" :rows="2" placeholder="请输入详细地址" v-model="address"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAdr()" :loading="loading1">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="更改收货地址" :visible.sync="changeDialog" width="50%">
      <div
        class="address-item"
        v-for="(key,index) of current_address"
        :key="index"
        @mouseover="active = index"
        @mouseleave="active = -1"
        :class="active == index|| addressKey == key.id?'active':''"
        @click="setAddress(key.id)"
      >
        <el-row>
          <el-col :span="4">收件人：</el-col>
          <el-col :span="12">{{key.name}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="4">手机号：</el-col>
          <el-col :span="12">{{key.mobile}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="4">收货地址：</el-col>
          <el-col :span="12">{{key.province + key.area + key.address}}</el-col>
          <el-col :span="4" :offset="4">
            <div class="eidt-adr" v-if="active == index" @click="setDefault(key.id)">设为默认地址</div>
            <div v-if="active != index && key.id == defaultId" class="default-adr">默认地址</div>
          </el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="changeDialog = false">取 消</el-button>
        <el-button type="primary" @click="setAAddress2()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="发票信息" :visible.sync="checkDialog" width="50%">
      <div>
        <div style="margin-bottom: 20px;">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-radio v-model="invoiceType" label="1" border>电子发票（非纸质）</el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio v-model="invoiceType" label="2" border>普通发票（纸质）</el-radio>
            </el-col>
            <el-col :span="24">
              <div class="error" v-if="error.err1.length>0">{{error.err1}}</div>
            </el-col>
          </el-row>
        </div>
        <div style="margin-bottom: 20px;">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-radio v-model="invoiceType2" label="1" border>个人</el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio v-model="invoiceType2" label="2" border>单位</el-radio>
            </el-col>
            <el-col :span="24">
              <div class="error" v-if="error.err2.length>0">{{error.err2}}</div>
            </el-col>
          </el-row>
        </div>
        <div style="margin-bottom: 20px;">
          <el-input v-model="invoiceTitle" placeholder="发票抬头"></el-input>
          <div class="error" v-if="error.err3.length>0">{{error.err3}}</div>
        </div>
        <div style="margin-bottom: 20px;">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-input v-model="invoiceMobile" placeholder="收票人手机"></el-input>
              <div class="error" v-if="error.err4.length>0">{{error.err4}}</div>
            </el-col>
            <el-col :span="12">
              <el-input v-model="invoiceEmail" placeholder="收票人邮箱"></el-input>
              <div class="error" v-if="error.err5.length>0">{{error.err5}}</div>
            </el-col>
          </el-row>
        </div>
        <div style="margin-bottom: 20px;">发票内容</div>
        <div style="margin-bottom: 20px;">
          <el-row :gutter="20">
            <el-col :span="4">
              <el-radio v-model="invoiceType3" border label="试剂">试剂</el-radio>
            </el-col>
            <el-col :span="4">
              <el-radio v-model="invoiceType3" border label="设备">设备</el-radio>
            </el-col>
            <el-col :span="4">
              <el-radio v-model="invoiceType3" border label="耗材">耗材</el-radio>
            </el-col>
            <el-col :span="4">
              <el-radio v-model="invoiceType3" border label="抗体">抗体</el-radio>
            </el-col>
            <el-col :span="4">
              <el-radio v-model="invoiceType3" border label="技术服务">技术服务</el-radio>
            </el-col>
          </el-row>
        </div>
        <div style="margin-bottom: 20px;">
          <el-input v-model="invoiceText" placeholder="开票内容"></el-input>
          <div class="error" v-if="error.err6.length>0">{{error.err6}}</div>
        </div>
        <div class="notice">
          <div>发票须知：</div>
          <div>1.宝枫林商城纸质发票暂不支持填写税号；</div>
          <div>2.选择电子发票的订单付款后纳税人识别号不可修改，请确认信息后付款；</div>
          <div>3.电子发票可在订单完成后，在订单详情中下载和查看。</div>
          <div>4.发票金额为实际支付金额，不含优惠券、礼品卡等。</div>
          <div>
            <router-link to="/#">查看更多发票常见问题 ></router-link>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="SubmitInvoice()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑收货地址" :visible.sync="editDialog" width="50%">
      <div>
        <el-row :gutter="50" style="margin-bottom:20px">
          <el-col :span="12">
            <el-input v-model="a_name" placeholder="请输入收货人姓名"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="a_mobile" placeholder="请输入收货人手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="6">
            <el-select v-model="a_address1" placeholder="请选择" @change="handeladr1">
              <el-option v-for="item in adr1" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="a_address2" placeholder="请选择" @change="handeladr2">
              <el-option v-for="item in adr2" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="a_address3" placeholder="请选择" @change="handeladr3">
              <el-option v-for="item in adr3" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <div style="margin-top:20px;">
          <el-input type="textarea" :rows="2" placeholder="请输入详细地址" v-model="a_address"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitNewAddress()" :loading="loading1">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      submitLoading: false,
      mobile1: "",
      a_name: "",
      a_id: "",
      a_mobile: "",
      a_address1: "",
      a_address2: "",
      a_address3: "",
      a_address: "",
      a_zipcode: "",
      editDialog: false,
      invoiceText: "",
      invoiceTitle: "",
      invoiceType3: "",
      invoiceType2: "",
      invoiceType: "",
      invoice: false,
      invoiceMobile: "",
      invoiceEmail: "",
      tableData: null,
      current_address: null,
      addDialog: false,
      changeDialog: false,
      checkDialog: false,
      name: "",
      mobile: "",
      adr1: null,
      adr2: null,
      adr3: null,
      address1: "",
      address2: "",
      address3: "",
      address: "",
      code: "",
      area: "",
      way1: null,
      way2: null,
      addressKey: null,
      active: null,
      check: false,
      defaultId: null,
      couponsId: 0,
      error: {
        err1: "",
        err2: "",
        err3: "",
        err4: "",
        err5: "",
        err6: ""
      },
      invoiceId: 0,
      total: 0,
      freight: 0,
      realTotal: 0,
      loading1: false
    };
  },
  watch: {},
  created() {
    //
    this.$store.state.cart_show = false;
    this.loadCart();
    this.loadAddress();
    this.loadAdr1();
  },
  methods: {
    //
    handelAddClose() {
      this.name = null;
      this.address1 = null;
      this.address2 = null;
      this.address3 = null;
      this.address = null;
      this.mobile1 = null;
    },
    SubmitInvoice() {
      var allow = true;
      if (this.invoiceType.length > 0) {
        this.error.err1 = "";
      } else {
        this.error.err1 = "未选择发票类型";
        allow = false;
      }

      if (this.invoiceType2.length > 0) {
        this.error.err2 = "";
      } else {
        this.error.err2 = "未选择发票类型";
        allow = false;
      }

      if (this.invoiceTitle.length > 0) {
        this.error.err3 = "";
      } else {
        this.error.err3 = "未填写发票抬头";
        allow = false;
      }

      if (this.invoiceMobile > 0) {
        this.error.err4 = "";
      } else {
        this.error.err4 = "未填写收票人手机号";
        allow = false;
      }

      if (this.invoiceEmail.length > 0) {
        this.error.err5 = "";
      } else {
        this.error.err5 = "未填写收票人邮箱";
        allow = false;
      }

      if (this.invoiceText.length + this.invoiceType2.length > 0) {
        this.error.err6 = "";
      } else {
        this.error.err6 = "未填写发票内容";
        allow = false;
      }

      if (!allow) {
        return;
      }

      var that = this;
      var json = {
        type: this.invoiceType,
        type1: this.invoiceType2,
        head: this.invoiceTitle,
        invoice_mobile: this.invoiceMobile,
        invoice_email: this.invoiceEmail,
        content: this.invoiceType3 + "," + this.invoiceText,
        mobile: this.$cookies.get("user"),
        token: this.$cookies.get("token")
      };
      this.axios
        .get(this.serve + "/member/create_invoice", {
          params: json
        })
        .then(res => {
          if (res.data.status == "success") {
            this.invoiceId = res.data.data;
            this.checkDialog = false;
          }
        });
    },
    submitNewAddress() {
      //
      this.loading1 = true;
      var that = this;
      var json = {
        mobile: this.$cookies.get("user"),
        token: this.$cookies.get("token"),
        id: this.a_id,
        a_mobile: this.a_mobile,
        province: this.a_address1,
        city: this.a_address2,
        area: this.a_address3,
        address: this.a_address,
        name: this.a_name
      };
      this.axios
        .get(this.serve + "/member/change_address_info", {
          params: json
        })
        .then(res => {
          if (res.data.status == "success") {
            that.editDialog = false;
            this.loading1 = false;
          }
        });
    },
    submit() {
      var that = this;
      this.submitLoading = true;
      var json = {
        mobile: this.$cookies.get("user"),
        token: this.$cookies.get("token"),
        address_id: this.a_id,
        pay_type: this.way1,
        invoice_id: this.invoiceId,
        coupons_id: this.couponsId,
        all_money: this.total,
        pay_money: this.realTotal,
        product_list: JSON.stringify(this.tableData)
      };
      this.axios
        .get(this.serve +"/member/create_order", {
          params: json
        })
        .then(res => {
          if (res.data.status == "success") {
            this.submitLoading = false;
            var orderCode = res.data.data;
            if (this.way1 == 1) {
              this.$router.push("/user/pay?order=" + orderCode);
            } else if (this.way1 == 2) {
              this.$router.push("/user/finish1?order=" + orderCode);
            }
          }
        });
    },
    setDefault(id) {
      var that = this;
      this.axios
        .get(this.serve +"/member/set_default_address", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            that.loadAddress();
          }
        });
    },
    setAddress(id) {
      this.addressKey = id;
    },
    submitAdr() {
      var that = this;
      this.loading1 = true;
      this.axios
        .get(this.serve +"/member/add_address", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            name: this.name,
            province: this.address1,
            city: this.address2,
            area: this.address3,
            address: this.address,
            a_mobile: this.mobile1
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.loadAddress();
            this.addDialog = false;
            this.loading1 = false;
          }
        });
      this.code = "";
    },
    handeladr1(v) {
      this.loadAdr2(v);
    },
    handeladr2(v) {
      this.loadAdr3(v);
    },
    handeladr3(v) {
      this.area = v;
    },
    loadAdr1() {
      var that = this;
      this.axios.get(this.serve +"/province").then(res => {
        that.adr1 = res.data;
        that.adr2 = null;
        that.adr3 = null;
      });
    },
    loadAdr2(v) {
      var that = this;
      this.axios.get(this.serve +"/city?name=" + v).then(res => {
        that.adr2 = res.data;
        that.adr3 = null;
      });
    },
    loadAdr3(v) {
      var that = this;
      this.axios.get(this.serve +"/area?name=" + v).then(res => {
        that.adr3 = res.data;
      });
    },
    editAdr() {
      this.changeDialog = true;
    },
    addAdr() {
      this.addDialog = true;
    },
    loadCart() {
      var that = this;
      this.tableData = JSON.parse(this.$route.query.cart);
      that.total = 0;
      for (var item of that.tableData) {
        let price = item.selling_price * item.number;
        that.total += price;
      }
      if (that.total < 1000) {
        that.freight = 20;
      } else {
        that.freight = 0;
      }
      that.realTotal = that.total - that.freight;
    },
    loadAddress() {
      var that = this;
      this.axios
        .get(this.serve +"/member/get_address", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          var json = res.data.data.results;
          that.current_address = res.data.data;
          if (Object.keys(json).length == 0) {
          } else {
            that.current_address = res.data.data.results;
            that.addressKey = res.data.data.default;
            that.defaultId = res.data.data.default;
            that.setAAddress();
          }
        });
    },
    setAAddress() {
      for (var item of this.current_address) {
        if (item.id == this.addressKey) {
          this.a_id = item.id;
          this.a_name = item.name;
          this.a_mobile = item.mobile;
          this.a_address1 = item.province;
          this.a_address2 = item.city;
          this.a_address3 = item.area;
          this.a_address = item.address;
          this.a_zipcode = item.zipCode;
        }
      }
    },
    setAAddress2() {
      this.changeDialog = false;
      for (var item of this.current_address) {
        if (item.id == this.addressKey) {
          this.a_id = item.id;
          this.a_name = item.name;
          this.a_mobile = item.mobile;
          this.a_address1 = item.province;
          this.a_address2 = item.city;
          this.a_address3 = item.area;
          this.a_address = item.address;
          this.a_zipcode = item.zipCode;
        }
      }
    }
  }
};
</script>
<style lang="scss">
#createOrder {
  .error {
    color: #e2211c;
    padding: 5px;
  }
  .el-radio__input {
    display: none;
  }
  .el-radio {
    width: 100%;
    text-align: center;
  }
  padding-bottom: 40px;
  .check-btn {
    svg {
      margin-right: 5px;
    }
  }
  .default-adr {
    color: #808080;
    font-size: 13px;
  }
  .address-item {
    line-height: 1.5em;
    border: 1px solid #ddd;
    padding: 10px 20px;
    margin-bottom: 20px;
  }
  .address-item.active {
    border: 1px solid #e2211c;
  }
  .submit {
    width: 150px;
    line-height: 20px;
    font-size: 18px;
    margin-bottom: 40px;
  }
  .bot-text {
    text-align: right;
    line-height: 2em;
    margin-bottom: 40px;
  }
  .coupon {
    border: 1px solid #e2211c;
    .el-row {
      margin-bottom: -5px;
    }
  }
  .coupon-left {
    position: relative;
    top: 50%;
    margin-top: -1em;
    color: #fff;
  }
  .coupon-right {
    margin: 2em;
  }
  .adr-left {
    border-right: 1px solid #ddd;
    padding: 5px 0;
    line-height: 1.5em;
  }
  .eidt-adr {
    color: #e2211c;
    font-size: 13px;
    cursor: pointer;
  }
  .adr-btn {
    background-color: #f5f5f5;
    border: 1px solid #dddd;
    display: block;
    text-align: center;
    color: #333;
    line-height: 45px;
    cursor: pointer;
    svg {
      margin-right: 5px;
    }
  }
  .finish {
    color: #fff;
    background-color: #e2211c;
    height: 80px;
    display: block;
    width: 100%;
    border: 0;
    font-size: 18px;
    letter-spacing: 0.2em;
  }
  .finish:hover {
    cursor: pointer;
    background-color: #ff6073;
  }

  .table {
    border: 1px solid #ddd;
    background-color: #fff;
    padding: 0 20px;
  }
  .form {
    border: 1px solid #ddd;
    padding: 20px;
  }
  .title {
    color: #666666;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
  }
  .btn {
    background-color: #f5f5f5;
    color: #666666;
    padding: 15px 20px;
    border: 1px solid #dddddd;
    cursor: pointer;
  }
  .btn:hover,
  .btn.active {
    border-color: #e2211c;
    color: #e2211c;
  }

  .row-header {
    background-color: #f2f2f2;
    th {
      background: #f2f2f2;
    }
  }
  .list {
    margin-top: 40px;
    border: 1px solid #ddd;
  }
  .underline {
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
  }
}
</style>